import { Divider } from "antd";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  analytics_cards,
  analytics_cards_all,
  analytics_cards_export,
} from "../../actions/cards/cards";
import { amountFormat } from "../../utils";
import BarGraph from "./BarGraph";
import ReportTable from "./ReportTable";
import MISExpenses from "../Common/PDF/MISPDF/MISExpenses";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import BaseCurrency from "../Common/BaseCurrency";

const Expenses = ({
  showGraph,
  apiFilters,
  filterObj,
  setFilterObj,
  pdfURL,
}) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.analytics.analytics_cards);
  const pdfData = useSelector((state) => state.analytics.analytics_cards_all);
  useEffect(() => {
    dispatch(analytics_cards({ type: "expenses" }));
    dispatch(analytics_cards_all({ type: "expenses", csv: true }));
    dispatch(
      analytics_cards_export({ pdf: true, csv: true, type: "expenses" })
    );
    setFilterObj({});
    // eslint-disable-next-line
  }, []);

  const downloadPdf = async () => {
    const blob = await pdf(
      <MISExpenses data={pdfData?.data?.response?.transaction || []} />
    ).toBlob();
    saveAs(blob, "MISExpense.pdf");
  };

  useEffect(() => {
    pdfURL(downloadPdf);
  }, [pdfData]);

  const getObjs = () => {
    if (cards?.data?.response?.transaction?.length > 0) {
      return cards?.data?.response?.transaction?.[0]?.custom_fields?.map(
        (ele) => ({
          title: ele.key?.replace("_", " "),
          dataIndex: "custom_fields",
          key: "custom_fields",
          render: (text, data) => (
            <div>
              {data?.custom_fields?.find((itm) => itm.key === ele.key)?.value}
            </div>
          ),
        })
      );
    }

    return [];
  };

  const handlePaginationCall = (vals) => {
      vals.type = "expenses";
      
      const finalVals = {};
      for (const key in vals) {
        if (Array.isArray(vals[key])) {
          finalVals[key] = vals[key].join(',');
        } else {
          finalVals[key] = vals[key];
        }
      }
      
      dispatch(analytics_cards(finalVals));
      dispatch(analytics_cards_export({ pdf: true, csv: true, ...finalVals }));
    }

  const columns = useMemo(
    () => [
      {
        title: "Transaction ID",
        dataIndex: "transaction_number",
        key: "transaction_number",
        render: (text, data) => {
          return (
            <div className={`render_common_style status_${data?.Status}`}>
              {text}
            </div>
          );
        },
      },
      {
        title: "Merchant Name",
        dataIndex: "merchant",
        key: "merchant",
      },
      {
        title: "Employee Name",
        dataIndex: "employee_name",
        key: "employee_name",
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
      },
      {
        title: "Report ID",
        dataIndex: "report_number",
        key: "report_number",
      },
      {
        title: "Report Name",
        dataIndex: "report_name",
        key: "report_name",
      },
      {
        title: "Transaction date",
        dataIndex: "transaction_date",
        key: "transaction_date",
      },
      {
        title: "Submitted On",
        dataIndex: "report_submitted_on",
        key: "report_submitted_on",
      },
      {
        title: "Amount",
        dataIndex: "transaction_amount",
        key: "transaction_amount",
        render: (text) => (
          <div>
            <BaseCurrency /> {amountFormat(text)}
          </div>
        ),
      },
      ...getObjs(),
      // eslint-disable-next-line
    ],
    [cards]
  );

  return (
    <>
      <div className="reports">
        {showGraph && (
          <>
            <Divider />
            <div
              className="mt1"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <BarGraph
                width={1000}
                height={350}
                id={"lineAreaGraph"}
                data={[
                  { day: "Jan", txnValue: 39 },
                  { day: "Feb", txnValue: 49 },
                  { day: "Mar", txnValue: 69 },
                  { day: "Apr", txnValue: 59 },
                ]}
                barColor={"#F48C32"}
              />
            </div>
          </>
        )}
        <Divider />
      </div>
      <ReportTable
        columns={columns}
        // scroll={{ x: 1400 }}
        data={cards?.data?.response?.transaction || []}
        total_records={cards?.data?.total_records}
        scroll={{ x: 2000 }}
        paginationCall={handlePaginationCall}
        payload={{ ...filterObj, ...apiFilters }}
      />
    </>
  );
};

export default Expenses;
